import { useNavigate } from 'react-router';
import { useState, useEffect } from 'react';
import { createSearchParams } from 'react-router-dom';

import { NotFound } from '@/components/Pages/Errors/NotFound';
import Layout from './Layout';
import MainMenuForm from './MainMenuForm';
import { PageNames } from '../types/PageName';
import { MainUrls } from '../constants/urls';

export function TopPage() {
  const navigate = useNavigate();
  const [destination, setDestination] = useState({ pathname: '', search: '' });
  const [activePage, setActivePage] = useState(PageNames.Main);

  useEffect(() => {
    if (Object.values(MainUrls).includes(destination.pathname)) {
      navigate(`${destination.pathname}${destination.search || ''}`);
    }
  }, [destination]);

  // QRページ実装に向けて残してあります
  function toFacilityList(redirect: string) {
    setDestination({
      pathname: MainUrls.Facilities,
      search: `?${createSearchParams({ redirect: redirect })}`
    });
  }

  switch (activePage) {
    case PageNames.Main:
      return (
        <Layout noTitle>
          <MainMenuForm setActivePage={setActivePage} setDestination={setDestination} toFacilityList={toFacilityList} />
        </Layout>
      );
    default:
      return <NotFound />;
  }
}

export default TopPage;
